<template>
    <GuestLayout>
        <FullscreenLoading v-if="isLoading" />

        <div class="container-fluid d-flex flex-column">
            <div class="row justify-content-center min-vh-100">
                <div class="col-md-6 col-lg-5 col-xl-4 py-6 py-md-0 mt-10">
                    <div class="card" style="max-width: 600px; margin: 0 auto;">
                        <div class="d-flex justify-content-end mr-2 mt-1">
                            <LanguageSwitcher />
                        </div>

                        <div class="card-body">
                            <div class="card-header text-center mb-5">
                                <img src="../../assets/lite/Logo-Text-Below.svg" style="height: 140px;" />
                            </div>

                            <div>
                                <div v-if="!linkSent">
                                    <ForgotPasswordForm id="password-reset-form" :initial-values="resetPasswordValues" @submit="resetPassword" />

                                    <div class="mt-4">
                                        <button type="submit" form="password-reset-form" class="btn btn-block btn-primary">{{ $t('register.reset_password_title') }}</button>
                                    </div>

                                </div>
                                <div class="alert alert-success" v-else>
                                    {{ $t('register.success_email_sent_message') }}
                                </div>

                                <div class="mt-3 text-center">
                                    <router-link :to="{ name: 'register' }">{{ $t('register.register_link') }}</router-link>
                                    |
                                    <router-link :to="{ name: 'login' }">{{ $t('register.login_link') }}</router-link>
                                </div>

                                <div class="alert alert-danger mt-5" v-if="errorMessage">{{ errorMessage }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </GuestLayout>
</template>
<script>

    import { mapState } from 'vuex';
    import GuestLayout from './GuestLayout.vue';
    import FullscreenLoading from '../../components/FullscreenLoading.vue';
    import i18n from '../../utils/locale';
    import LanguageSwitcher from '../../components/LanguageSwitcher.vue';
    import ForgotPasswordForm from '../../forms/ForgotPasswordForm.vue';
    import { AccountService } from '../../services/accountService';

    export default {
        components: {
            GuestLayout,
            ForgotPasswordForm,
            FullscreenLoading,
            LanguageSwitcher,
        },

        computed: mapState({
            user: state => state.user,
        }),

        data() {
            return {
                isLoading: false,
                errorMessage: null,
                linkSent: false,
                resetPasswordValues: {
                    email: null,
                },
            };
        },

        methods: {
            async resetPassword(data) {
                this.isLoading = true;
                this.errorMessage = null;

                try {
                    await AccountService.getInstance().sendPasswordResetLink(data.email);
                    this.linkSent = true;
                } catch (exception) {
                    this.errorMessage = exception?.message || i18n.t('general.something_went_wrong');
                } finally {
                    this.isLoading = false;
                }
            },
        },
    };

</script>
